import { render, staticRenderFns } from "./ImportantDisclosure.vue?vue&type=template&id=19ba8d65&"
import script from "./ImportantDisclosure.vue?vue&type=script&lang=js&"
export * from "./ImportantDisclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports